import { ICONS } from "@/lib/icons";
import { Reveal, SectionHeading } from "./Reveal";

export default function Benefits({ content }) {
  const c = content?.benefits;
  return (
    <section id="benefits" className="bg-cream-deep py-24 sm:py-28">
      <div className="mx-auto max-w-7xl px-5">
        <SectionHeading eyebrow={c?.eyebrow} title={c?.title} />
        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {(c?.items || []).map((item, i) => {
            const Icon = ICONS[item.icon] || ICONS.star;
            return (
              <Reveal key={i} delay={0.08 * i} className="h-full">
                <article
                  data-testid={`benefit-card-${i}`}
                  className="group flex h-full flex-col items-center rounded-3xl border border-line bg-white p-8 text-center transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_50px_-24px_rgba(15,56,44,0.35)]"
                >
                  <span className="flex h-14 w-14 items-center justify-center rounded-full bg-forest-900 text-gold transition group-hover:scale-110">
                    <Icon className="h-6 w-6" />
                  </span>
                  <h3 className="mt-5 font-head text-lg font-bold text-forest-950">{item.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-moss">{item.desc}</p>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
